
import { ServiceLandingPage } from "@/components/service/ServiceLandingPage";

const RestorationPage = () => {
  const features = [
    {
      title: "Water Damage Restoration",
      description: "Quick response to minimize damage from flooding and water intrusion"
    },
    {
      title: "Fire & Smoke Damage",
      description: "Comprehensive cleanup and restoration after fire damage"
    },
    {
      title: "Mold Remediation",
      description: "Safe removal of mold and prevention of future growth"
    },
    {
      title: "Storm Damage",
      description: "Rapid repairs after severe weather events"
    },
    {
      title: "Content Cleaning",
      description: "Restoration of furniture, documents, and personal belongings"
    }
  ];

  const processSteps = [
    {
      title: "24/7 Emergency Response",
      description: "Technicians arrive quickly to assess damage and begin mitigation"
    },
    {
      title: "Damage Assessment",
      description: "Thorough inspection to determine the extent of damage"
    },
    {
      title: "Water Extraction & Drying",
      description: "Industrial equipment removes water and completely dries affected areas"
    },
    {
      title: "Cleaning & Sanitizing",
      description: "Thorough cleaning to remove contaminants and prevent mold growth"
    },
    {
      title: "Complete Restoration",
      description: "Repairs and rebuilding to return your property to pre-damage condition"
    }
  ];

  const benefits = [
    {
      title: "IICRC Certified Technicians",
      description: "Trained professionals following industry standards"
    },
    {
      title: "Direct Insurance Billing",
      description: "We work directly with your insurance company for a smoother process"
    },
    {
      title: "Advanced Equipment",
      description: "State-of-the-art tools for efficient water extraction and drying"
    },
    {
      title: "Rapid Response",
      description: "24/7 emergency services with quick arrival times"
    },
    {
      title: "Complete Documentation",
      description: "Detailed records of damage and restoration work for insurance claims"
    }
  ];

  return (
    <ServiceLandingPage
      title="Restoration Services"
      metaDescription="Professional water, fire, and storm damage restoration services in Oklahoma City."
      introText="Fast, reliable restoration services for homes and businesses damaged by water, fire, or storms in Oklahoma City."
      features={features}
      processSteps={processSteps}
      benefits={benefits}
      ctaText="Don't wait when disaster strikes!"
      ctaButtonText="Get Emergency Help"
      contactText="Contact us now for immediate assistance with your restoration needs."
    />
  );
};

export default RestorationPage;
